import { Banner } from '@ingenico/react-ui/banner';
import { CoreContainer } from '@ingenico/react-ui/core-container';
import { DATAGRID_ROWS_PER_PAGE_OPTIONS, DataGridCore, ListViewContainer } from '@ingenico/react-ui/datagrid';
import { NoticeCard } from '@ingenico/react-ui/notice-card';
import { LinearProgress } from '@mui/material';
import { useCallback } from 'react';
import { useDeviceDiagnosticsListContent } from './DeviceDiagnosticsListContent.vm';

export function DeviceDiagnosticsListContent() {
  const {
    columns,
    filteredDeviceDiagnosticsLogsData,
    deviceDiagnosticsLogsQuery,
    gridProps,
    errorMessage,
    isFirstLoading,
    noRowsProps,
    errorStatus,
    errorTitle,
  } = useDeviceDiagnosticsListContent();

  const getDeviceDiagnosticsComponent = useCallback(() => {
    switch (errorStatus) {
      case 404: {
        return <NoticeCard image="not-found" isBordered message={errorMessage} title={errorTitle} />;
      }
      default: {
        return <Banner message={errorMessage} />;
      }
    }
  }, [errorMessage, errorStatus, errorTitle]);

  return (
    <>
      {isFirstLoading && <LinearProgress />}
      {deviceDiagnosticsLogsQuery.isError && errorMessage && (
        <CoreContainer>{getDeviceDiagnosticsComponent()}</CoreContainer>
      )}
      {gridProps?.shouldDisplayGrid && (
        <CoreContainer>
          <ListViewContainer>
            <DataGridCore
              apiRef={gridProps.datagridRef}
              columnBufferPx={5}
              columns={columns}
              getRowId={gridProps.getRowId}
              headerHeightPixels={395}
              initialState={{
                pagination: { paginationModel: { pageSize: DATAGRID_ROWS_PER_PAGE_OPTIONS[0], page: 0 } },
              }}
              loading={deviceDiagnosticsLogsQuery.isLoading}
              noRowsProps={noRowsProps}
              onPaginationModelChange={gridProps.handlePaginationModelChange}
              onRowClick={gridProps.handleRowClick}
              onSortModelChange={gridProps.handleSortModelChange}
              paginationMode="server"
              rowCount={gridProps.total}
              rows={filteredDeviceDiagnosticsLogsData}
              pageSizeOptions={DATAGRID_ROWS_PER_PAGE_OPTIONS}
              sortingMode="server"
            />
          </ListViewContainer>
        </CoreContainer>
      )}
    </>
  );
}
